/* This reducer is used for fetching surgery details */

import { isTransferSurgery } from 'src/utils/util';
import storage from 'redux-persist/lib/storage';

import {
    SURGERY_GET_IMAGE_PO_PREVIEW,
    SURGERY_GET_IMAGE_PO_PREVIEW_FAILURE,
    SURGERY_GET_IMAGE_PO_PREVIEW_SUCCESS,
    SURGERY_RESET_PO_ATTACHMENT,
} from '../actions/actionTypes';
import {
    GET_IMAGE_PO_PREVIEW,
    GET_IMAGE_PO_PREVIEW_FAILURE,
    GET_IMAGE_PO_PREVIEW_SUCCESS,
    GET_SCHEDULE_SURGERY_DETAILS,
    GET_SCHEDULE_SURGERY_DETAILS_FAILURE,
    GET_SCHEDULE_SURGERY_DETAILS_SUCCESS,
    GET_SURGERY_DETAILS,
    GET_SURGERY_DETAILS_FAILURE,
    GET_SURGERY_DETAILS_SUCCESS,
    RESET_SURGERY_DETAILS_REDUCER,
    SET_FOOTER_FROM_TRANSFER_SURGERY,
    SURGERY_ATTACHMENT_UPLOAD,
    SURGERY_ATTACHMENT_UPLOAD_FAILURE,
    SURGERY_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE,
    SURGERY_ATTACHMENT_UPLOAD_SUCCESS_TISSUE,
    SURGERY_DELETE_ATTACHMENT_REQUEST,
    SURGERY_DELETE_ATTACHMENT_REQUEST_SUCCESS,
    SURGERY_DELETE_ATTACHMENT_REQUEST_FAILURE,
} from '../actions';
import persistReducer from 'redux-persist/es/persistReducer';

const initialState = {
    surgeryData: {},
    loading: false,
    statusCode: 0,
    statusMessage: '',
    showFooterTransferSurgery: false,
    productWithIsPlaceHolderSet: [],
    productWithIsDeleteButtonPresent: [],
    surgeryDetails: {
        myCaseRef: '',
        myCaseRefValue: '',
    },
    myCaseRefId: null,
    isdeletionDone: false,
    isUsageAttachmentUploaded: false,
    poTissueImageDetails: '',
    poNonTissueImageDetails: '',
    poImagePreviewLoader: false,
    poImagePreviewDetails: null,
    poImageUploadLoader: false,
    poImageDeleteLoader: false,
    existingShippingAddress: {},
};

const getSurgeryDataFromPayload = (state, surgeryData) => {
    if (isTransferSurgery()) {
        surgeryData.surgeryDetails.surgeryDateTime = '';
    }
    return {
        ...state.surgeryData,
        ...surgeryData,
    };
};

const surgeryDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SURGERY_DETAILS:
            return {
                ...state,
                surgeryData: {},
                loading: true,
            };
        case GET_SURGERY_DETAILS_SUCCESS:
            return {
                ...state,
                surgeryData: getSurgeryDataFromPayload(
                    state,
                    action.payload.surgeryData
                ),
                productWithIsPlaceHolderSet:
                    action.payload.surgeryData?.products?.filter(
                        (data) => data?.isPlaceHolderAdded
                    ) || [],
                productWithIsDeleteButtonPresent:
                    action.payload.surgeryData?.products?.filter(
                        (data) => data?.isDeleteButtonPresent === false
                    ) || [],
                // myCaseRef: action.payload.surgeryDetails.myCaseRef,
                statusCode: action.payload.statusCode,
                statusMessage: action.payload.statusMessage,
                loading: false,
                existingShippingAddress: action.existingShippingAddress,
            };

        case GET_SURGERY_DETAILS_FAILURE:
            return {
                ...state,
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
            };
        case GET_SCHEDULE_SURGERY_DETAILS:
            return {
                ...state,
                surgeryDetails: {
                    myCaseRef: '',
                    myCaseRefValue: '',
                },
            };
        case GET_SCHEDULE_SURGERY_DETAILS_SUCCESS: {
            return {
                ...state,
                surgeryDetails: {
                    myCaseRef: action.myCaseRef,
                },
            };
        }
        case GET_SCHEDULE_SURGERY_DETAILS_FAILURE: {
            return {
                ...state,
                surgeryDetails: {
                    myCaseRef: '',
                    myCaseRefValue: '',
                },
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
            };
        }
        case SET_FOOTER_FROM_TRANSFER_SURGERY:
            return {
                ...state,
                showFooterTransferSurgery: action.payload,
            };
        case RESET_SURGERY_DETAILS_REDUCER: {
            return {
                ...state,
                ...initialState,
                myCaseRefId: null,
            };
        }
        case SURGERY_ATTACHMENT_UPLOAD:
            return {
                ...state,
                poImageUploadLoader: true,
            };
        case SURGERY_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE:
            return {
                ...state,
                poNonTissueImageDetails: action.payload,
                poImageUploadLoader: false,
            };
        case SURGERY_ATTACHMENT_UPLOAD_SUCCESS_TISSUE:
            return {
                ...state,
                poTissueImageDetails: action.payload,
                poImageUploadLoader: false,
            };
        case SURGERY_DELETE_ATTACHMENT_REQUEST_SUCCESS:
            return {
                ...state,
                poTissueImageDetails: action.payload.isTissue
                    ? action.payload.imagesToBeUpdated
                    : state.poTissueImageDetails,
                poNonTissueImageDetails: !action.payload.isTissue
                    ? action.payload.imagesToBeUpdated
                    : state.poNonTissueImageDetails,
                poImageDeleteLoader: false,
            };
        case SURGERY_DELETE_ATTACHMENT_REQUEST_FAILURE:
            return {
                ...state,
                isdeletionDone: false,
                poImageDeleteLoader: false,
            };
        case SURGERY_ATTACHMENT_UPLOAD_FAILURE:
            return {
                ...state,
                isUsageAttachmentUploaded: false,
                poImageUploadLoader: false,
            };
        case SURGERY_DELETE_ATTACHMENT_REQUEST:
            return {
                ...state,
                poImageDeleteLoader: true,
            };
        case GET_IMAGE_PO_PREVIEW:
            return {
                ...state,
                poImagePreviewLoader: true,
            };
        case GET_IMAGE_PO_PREVIEW_SUCCESS:
            return {
                ...state,
                poImagePreviewLoader: false,
                poImagePreviewDetails: action.payload,
            };
        case GET_IMAGE_PO_PREVIEW_FAILURE:
            return {
                ...state,
                poImagePreviewLoader: false,
                poImagePreviewDetails: null,
            };
        case SURGERY_RESET_PO_ATTACHMENT:
            return {
                ...state,
                poTissueImageDetails: '',
                poNonTissueImageDetails: '',
            };
        case SURGERY_GET_IMAGE_PO_PREVIEW:
            return {
                ...state,
                poImagePreviewLoader: true,
            };
        case SURGERY_GET_IMAGE_PO_PREVIEW_SUCCESS:
            return {
                ...state,
                poImagePreviewLoader: false,
                poImagePreviewDetails: action.payload,
            };
        case SURGERY_GET_IMAGE_PO_PREVIEW_FAILURE:
            return {
                ...state,
                poImagePreviewLoader: false,
                poImagePreviewDetails: null,
            };
        default: {
            return state;
        }
    }
};

// export default surgeryDetailsReducer;
export default persistReducer(
    {
        key: 'surgeryDetailsKey',
        storage: storage,
        //transforms: [SetTransform],
        whitelist: ['surgeryDetails'],
    },
    surgeryDetailsReducer
);
